import { infoCards } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20with%20dramatic%20lighting%20and%20empty%20leather%20executive%20chairs%2C%20power%20struggle%20investigation%20atmosphere%2C%20rich%20dark%20wood%20textures%20and%20warm%20amber%20accent%20lights%2C%20cinematic%20thriller%20composition%2C%20business%20conspiracy%20mood%2C%20high%20contrast%20professional%20photography&width=500&height=320&seq=info-card-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Luxury%20bank%20vault%20interior%20with%20dramatic%20golden%20spotlight%20on%20stacked%20documents%2C%20hidden%20wealth%20secrets%20atmosphere%2C%20expensive%20textures%20with%20deep%20mysterious%20shadows%2C%20cinematic%20wide%20shot%20composition%2C%20financial%20investigation%20aesthetic%2C%20warm%20metallic%20reflections&width=500&height=320&seq=info-card-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Empty%20television%20production%20control%20room%20with%20multiple%20monitors%20displaying%20static%20noise%2C%20behind%20the%20scenes%20documentary%20investigation%20style%2C%20technical%20broadcast%20equipment%20in%20dramatic%20moody%20lighting%2C%20dark%20journalistic%20atmosphere%2C%20surveillance%20and%20monitoring%20aesthetic&width=500&height=320&seq=info-card-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Single%20dramatic%20spotlight%20beam%20falling%20on%20empty%20stage%20floor%20with%20scattered%20papers%2C%20fallen%20microphone%20metaphor%2C%20dark%20theater%20atmosphere%20with%20deep%20shadows%2C%20cinematic%20symbolic%20composition%2C%20career%20downfall%20tension%20mood%2C%20artistic%20documentary%20photography&width=500&height=320&seq=info-card-4&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dramatic%20collage%20wall%20of%20vintage%20entertainment%20magazine%20covers%20and%20newspaper%20headlines%20with%20warm%20spotlight%20illumination%2C%20year%20in%20review%20retrospective%20aesthetic%2C%20rich%20warm%20tones%20against%20dark%20moody%20background%2C%20media%20history%20compilation%20atmosphere%2C%20editorial%20journalism%20photography&width=500&height=320&seq=info-card-5&orientation=landscape',
];

export default function InfoCardsSection() {
  return (
    <section id="cards" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4">
            深度内容
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            深度扒皮
          </h2>
          <p className="text-sm text-foreground-500 mt-2">专业团队深入调查的独家深度内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {infoCards.map((card, idx) => (
            <article
              key={card.id}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={cardImages[idx]}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
                  {card.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors mb-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400 pt-3 border-t border-background-200/70">
                  <span>{card.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.reads} 阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}